"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.LogoImage = exports.EditIcon = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _edit = _interopRequireDefault(require("../../assets/png/edit.png"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  height: 142px;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n"])));
exports.Wrapper = Wrapper;
var EditIcon = _styledComponents.default.img.attrs({
  src: _edit.default,
  alt: 'edit',
  role: 'button'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  width: 25px;\n  height: 25px;\n"])));
exports.EditIcon = EditIcon;
var LogoImage = _styledComponents.default.img.attrs({
  alt: 'logo'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n"])));
exports.LogoImage = LogoImage;
var Container = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 142px;\n  height: 142px;\n  align-self: center;\n  margin-top: -119px;\n  @media screen and (max-width: 420px) {\n    margin-top: -90px;\n  }\n"])));
exports.Container = Container;